export default __webpack_public_path__ + "static/media/goshoppi4.98edfa10.png";